export class PositionAggregation {
  costAmount: number;
  costAmountD: number;
  marketPrice: number;
  changeAvgSymbol: number;
  lastTime: any;
  marketValue: number;
  plusMinus: number;
  var: number;
  varD: number;
  portfolio: any;

  constructor(
    public position: any,
    public totalMarketValue: number,
    public operationTime: any,
    public solaceSymbol?: any,
  ) {
    this.costAmount = position.shares * position.averageCost;
    this.costAmountD = position.shares * position.instrument.closePrice;
    this.marketPrice = position.instrument.lastPrice;
    this.changeAvgSymbol = !solaceSymbol
      ? 0
      : solaceSymbol.hechos.body.variationPercentage / 100;
    this.marketValue = position.marketValue;
  }

  get issueId(): string {
    if (this.solaceSymbol) {
      if (this.lastTime !== this.solaceSymbol.hechos.body.Time) {
        this.processAggValues();
        this.lastTime = this.solaceSymbol.hechos.body.Time;
      }
    }

    return this.position.instrument.issueID;
  }

  get solaceTick(): string {
    let result = '';

    if (this.solaceSymbol) {
      if (this.lastTime !== this.solaceSymbol.hechos.body.Time) {
        this.processAggValues();
        this.lastTime = this.solaceSymbol.hechos.body.Time;
      }
      result = this.solaceSymbol.hechos.body.Time;
    }

    return result;
  }

  processAggValues(): void {
    if (
      this.position.positionValueType === 27 ||
      this.position.positionValueType === 150 ||
      this.position.positionValueType === 1000
    ) {
      this.marketValue = this.position.marketValue;
    } else {
      this.marketValue =
        this.position.instrument.lastPrice * this.position.shares;
    }
    this.plusMinus = this.marketValue - this.costAmount;
    this.var =
      this.costAmount !== 0 ? (this.plusMinus / this.costAmount) * 100 : 0;
    this.varD =
      this.costAmountD !== 0 ? (this.plusMinus / this.costAmountD) * 100 : 0;
    this.marketPrice = !this.solaceSymbol
      ? this.position.instrument.lastPrice
      : this.solaceSymbol.hechos.body.lastPrice;
    this.changeAvgSymbol = !this.solaceSymbol
      ? 0
      : this.solaceSymbol.hechos.body.variationPercentage / 100;
    // TODO: Check why is undefined and not 0.
    this.portfolio =
      this.totalMarketValue !== 0
        ? (this.marketValue / this.totalMarketValue) * 100
        : undefined;
    if (
      this.operationTime &&
      this.operationTime.endTime &&
      !!this.operationTime.endTime &&
      this.operationTime.endTime < Date.now() &&
      !!this.solaceSymbol &&
      this.solaceSymbol.hechos.body.weightedAvgPrice > 0
    ) {
      this.marketPrice = this.solaceSymbol.hechos.body.weightedAvgPrice;
    }
  }
}
